import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { volumes } from '../data/volumes';
export function VolumesSection() {
  return <section className="py-24 px-4 bg-ivory" data-id="element-287" data-mp="3uwgr2ofoecsq">
      <div className="max-w-6xl mx-auto" data-id="element-288" data-mp="cng5kpuinnc4">
        <div className="text-center mb-16" data-id="element-289" data-mp="cm526r4zghlj">
          <p className="text-gold-dark font-bold tracking-[0.2em] uppercase text-sm mb-3" data-id="element-290" data-mp="7p69md0ywipg">
            What You Get: 6 Complete Teaching Resources in One System
          </p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold mb-4 text-navy" data-id="element-291" data-mp="3c3w9i35ffu48">
            The 6-Volume Swim Instructor Library
          </h2>
          <p className="text-xl text-aqua-dark" data-id="element-292" data-mp="3pwly8fccbd51">
            120 Complete Lessons · Beginner to Advanced Development · Nothing to Build From
            Scratch
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-293" data-mp="2xdf9mo8fxc9g">
          {volumes.map((volume, index) => <motion.article key={volume.number} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-white rounded-2xl border-t-4 border-navy border-x border-b ${volume.popular ? 'border-x-gold/50 border-b-gold/50 shadow-[0_10px_30px_rgba(212,169,58,0.16)]' : 'border-x-pearl-dark border-b-pearl-dark shadow-sm'} p-8 flex flex-col h-full`} data-id="element-294" data-mp="2sevm4je77sez" data-mpi={index}>
              <div className="flex items-baseline justify-between gap-3 mb-4" data-id="element-295" data-mp="1vf7llk46ufgy">
                <span className="text-gold-dark font-bold text-sm uppercase tracking-[0.2em]" data-id="element-296" data-mp="20etyfsg3ttp8">
                  {volume.number}
                </span>
                <span className="text-xs font-semibold uppercase tracking-wider text-aqua-dark bg-aqua-light px-2.5 py-1 rounded-full" data-id="element-297" data-mp="24h764meew1on">
                  {volume.lessons}
                </span>
              </div>

              <h3 className="text-2xl font-serif font-bold leading-tight text-navy mb-3" data-id="element-298" data-mp="3ftrfjpsb8sm4">
                {volume.title}
              </h3>

              <p className="text-navy font-medium mb-5 italic border-l-2 border-gold pl-4" data-id="element-299" data-mp="1brzsttnpjlbf">
                {volume.subtitle}
              </p>

              <p className="text-graphite text-sm leading-relaxed mb-6" data-id="element-300" data-mp="1pqz84apbynux">{volume.intro}</p>

              <h4 className="text-sm font-bold text-navy uppercase tracking-wider mb-3" data-id="element-301" data-mp="1ktpk8zhlak97">
                {volume.bulletsTitle}
              </h4>
              <ul className="space-y-3 mb-6" data-id="element-302" data-mp="t18e0ckyb2pn">
                {volume.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-303" data-mp="16smwmiay51w6">
                    <CheckIcon size={18} className="text-aqua-dark shrink-0 mt-0.5" data-id="element-304" data-mp="16ty1ymk1ihpe" />
                    <span className="text-graphite text-sm" data-id="element-305" data-mp="120dbrgoous0r">{bullet}</span>
                  </li>)}
              </ul>

              <div className="mb-6" data-id="element-306" data-mp="e9zhdjimsh30">
                <h4 className="text-sm font-bold text-navy uppercase tracking-wider mb-2" data-id="element-307" data-mp="9e0wi5wihh7c">
                  What this solves for your teaching
                </h4>
                <p className="text-graphite text-sm leading-relaxed" data-id="element-308" data-mp="2prb27d3u7ofa">{volume.problem}</p>
              </div>

              <div className="bg-aqua-light border border-aqua/30 rounded-xl p-4 mt-auto" data-id="element-309" data-mp="2c06acx6po0fi">
                <span className="text-gold-dark font-bold text-xs uppercase tracking-[0.2em] block mb-1" data-id="element-310" data-mp="2gz0sry0rnmz3">
                  Result
                </span>
                <p className="text-navy text-sm" data-id="element-311" data-mp="34pwnp40iqyak">{volume.result}</p>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}